import { render, staticRenderFns } from "./CharacterItem.vue?vue&type=template&id=5cebb362&scoped=true"
import script from "./CharacterItem.vue?vue&type=script&lang=ts"
export * from "./CharacterItem.vue?vue&type=script&lang=ts"
import style0 from "./CharacterItem.vue?vue&type=style&index=0&id=5cebb362&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cebb362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cebb362')) {
      api.createRecord('5cebb362', component.options)
    } else {
      api.reload('5cebb362', component.options)
    }
    module.hot.accept("./CharacterItem.vue?vue&type=template&id=5cebb362&scoped=true", function () {
      api.rerender('5cebb362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/CharacterItem.vue"
export default component.exports